import React from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import ForgotPassword from "@/pages/ForgotPassword";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import Chat from "@/pages/Chat";
import Moods from "@/pages/Moods";
import Breathing from "@/pages/Breathing";
import Affirmations from "@/pages/Affirmations";
import Favorites from "@/pages/Favorites";
import Profile from "@/pages/Profile";
import Admin from "@/pages/Admin";
import AppLayout from "@/components/AppLayout";
import "@/App.css";

const ProtectedRoute = ({ children }) => {
    const { user, loading } = useAuth();
    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-background">
                <div className="text-muted-foreground font-heading text-lg">warming up…</div>
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;
    return children;
};

const AppRouter = () => {
    const location = useLocation();
    // Synchronous check — process OAuth callback BEFORE normal routing
    if (location.hash?.includes("session_id=")) {
        return <AuthCallback />;
    }
    return (
        <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/app" element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
                <Route index element={<Dashboard />} />
                <Route path="chat" element={<Chat />} />
                <Route path="chat/:sessionId" element={<Chat />} />
                <Route path="moods" element={<Moods />} />
                <Route path="breathing" element={<Breathing />} />
                <Route path="affirmations" element={<Affirmations />} />
                <Route path="favorites" element={<Favorites />} />
                <Route path="profile" element={<Profile />} />
                <Route path="admin" element={<Admin />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    );
};

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <AppRouter />
                    <Toaster position="top-center" richColors />
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
